module.exports = __webpack_public_path__ + "img/douyu.4eb543bd.png";